import {
  AddOnItem,
  AddOnItemName,
  Organization,
  OrganizationProfile,
  OrganizationVaProfile,
  VaOrganizationProfileStatus,
} from "schemas/dashboard";
import { routes } from "schemas/routes";

import { isPage } from "utils/general";
import { CURRENT_VA_STEP } from "utils/localStorage";

export function vaSelfServeNavigate(
  currentPathname: string,
  direction: "next" | "back",
) {
  let steps = [
    routes.welcomeSelfServeOnboarding,
    routes.aboutSelfServeOnboarding,
    routes.nicheSelfServeOnboarding,
    routes.templatesMethodSelfServeOnboarding,
  ];
  const currentStep = steps.findIndex((step) => currentPathname.endsWith(step));

  if (direction === "next" && currentStep < steps.length - 1) {
    return steps[currentStep + 1];
  } else if (direction === "back" && currentStep > 0) {
    return steps[currentStep - 1];
  } else {
    return currentPathname;
  }
}

export const getQuantityForItem = (
  addOnItemName: AddOnItemName,
  items: AddOnItem[],
) => {
  if (!items) return;
  const item = items.find((item) => item.itemName === addOnItemName);
  if (item) {
    return item.quantity;
  }
  return 0;
};

export const redirectToStep = (
  currentOrg: Organization,
  vaProfile: OrganizationVaProfile,
  organizationProfile: OrganizationProfile | null,
  addOnItems?: AddOnItem[],
  hasTemplate?: boolean,
  query?: string,
) => {
  if (vaProfile?.status === VaOrganizationProfileStatus.completed) {
    if (query?.includes(`${routes.pitchTrackerImport}`)) {
      return routes.dashboard;
    }
    if (isPage(routes.virtualAssistant)) {
      return routes.virtualAssistant;
    }
    return routes.faqSelfServeOnboarding;
  }
  const niches = vaProfile?.niches?.filter(
    (niche) => niche?.bentoCategoryId,
  )?.length;
  const hasNiches = niches && niches > 0;
  if (hasNiches) {
    const numOfTemplates =
      getQuantityForItem(AddOnItemName.pitching_templates, addOnItems || []) ||
      0;
    if (!hasTemplate) {
      return routes.templatesMethodSelfServeOnboarding;
    } else if (numOfTemplates > 0) {
      return routes.templatesCopyWriterSelfServeOnboarding;
    } else {
      return routes.faqSelfServeOnboarding;
    }
  }
  const hasUgcType =
    organizationProfile?.isUgcCreator || organizationProfile?.isInfluencer;

  const currentStep = localStorage.getItem(
    `${CURRENT_VA_STEP}-${currentOrg.id}`,
  );
  if (currentStep) {
    if (!hasUgcType) {
      return routes.aboutSelfServeOnboarding;
    }
    return routes.nicheSelfServeOnboarding;
  } else {
    return routes.welcomeSelfServeOnboarding;
  }
};
